import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12l14 0","key":"svg-0"}],["path",{"d":"M13 18l6 -6","key":"svg-1"}],["path",{"d":"M13 6l6 6","key":"svg-2"}]]

/**
 * IconArrowRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctcmlnaHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgMTJsMTQgMCIgLz4KICA8cGF0aCBkPSJNMTMgMThsNiAtNiIgLz4KICA8cGF0aCBkPSJNMTMgNmw2IDYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowRight = createReactComponent('outline', 'arrow-right', 'ArrowRight', __iconNode);

export default IconArrowRight;